(function () {
  function rngNext(state) {
    state.rngState = (state.rngState + 0x6D2B79F5) | 0;
    let t = state.rngState;
    t = Math.imul(t ^ (t >>> 15), 1 | t);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  }

  function rngInt(state, n) {
    return Math.floor(rngNext(state) * n);
  }

  function shuffle(state, arr) {
    for (let i = arr.length - 1; i > 0; i--) {
      const j = rngInt(state, i + 1);
      const tmp = arr[i];
      arr[i] = arr[j];
      arr[j] = tmp;
    }
    return arr;
  }

  function deepClone(x) {
    return JSON.parse(JSON.stringify(x));
  }

  const Kernel = {
    ENGINE_VERSION: 37,
    rngInt: rngInt,
    shuffle: shuffle,
    deepClone: deepClone,
    _journal: null,

    record(ev) {
      if (Kernel._journal) Kernel._journal.push(deepClone(ev));
    },

    newGame(setup) {
      return { version: Kernel.ENGINE_VERSION, setup: deepClone(setup), log: [] };
    },

    checkVersion(game) {
      const v = game.version === undefined ? 1 : game.version;
      if (v === Kernel.ENGINE_VERSION) return null;
      return "game was recorded on engine v" + v + " (current v" + Kernel.ENGINE_VERSION +
        ") - the replay may diverge if rules or card scripts changed";
    },

    computeState(game, upto) {
      const n = upto === undefined ? game.log.length : upto;
      let state = Engine.initialState(game.setup);
      Engine.advance(state);
      for (let i = 0; i < n; i++) {
        state = Kernel.step(state, game.log[i]);
      }
      return state;
    },

    replaySafe(game) {
      let state;
      try {
        state = Engine.initialState(game.setup);
        Engine.advance(state);
      } catch (e) {
        return { state: null, upto: 0, error: e.message };
      }
      for (let i = 0; i < game.log.length; i++) {
        const before = deepClone(state);
        try {
          state = Kernel.step(state, game.log[i]);
        } catch (e) {
          return { state: before, upto: i, error: e.message };
        }
      }
      return { state: state, upto: game.log.length, error: null };
    },

    step(state, action) {
      Engine.applyAction(state, action);
      Engine.advance(state);
      return state;
    },

    snapshot(state) {
      return deepClone(state);
    },

    tryStep(state, action) {
      const trial = deepClone(state);
      const prev = Kernel._journal;
      Kernel._journal = [];
      try {
        Engine.applyAction(trial, deepClone(action));
        Engine.advance(trial);
      } catch (e) {
        Kernel._journal = prev;
        return { ok: false, error: e.message, state: state, events: [] };
      }
      const events = Kernel._journal;
      Kernel._journal = prev;
      return { ok: true, state: trial, events: events };
    },

    dispatch(game, state, action) {
      const r = Kernel.tryStep(state, action);
      if (r.ok) game.log.push(deepClone(action));
      return r;
    },

    enumerateActions(state) {
      return RB.Enum.actions(state);
    },
  };

  window.Kernel = Kernel;
})();
